import { GA_TRACKING_ID } from './config';
import type { GAEvent } from './types';
import { hasAnalyticsConsent } from './consent';

// Initialize Google Analytics
export function initGA() {
  if (typeof window === 'undefined' || !hasAnalyticsConsent()) return;

  // Prevent multiple initializations
  if (window.gtag) return;

  // Add Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: any[]) {
    window.dataLayer.push(arguments);
  };
  
  window.gtag('js', new Date());
  window.gtag('config', GA_TRACKING_ID, {
    send_page_view: false, // We'll handle page views manually
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure',
    // Disable storage of personal data
    storage: 'none',
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
    restricted_data_processing: true
  });
}

// Track page views
export function trackPageView(path: string) {
  if (typeof window === 'undefined' || !window.gtag || !hasAnalyticsConsent()) return;

  // Only track anonymous page paths without query parameters
  const cleanPath = path.split('?')[0];
  window.gtag('config', GA_TRACKING_ID, {
    page_path: cleanPath,
    page_title: document.title
  });
}

// Track events
export function trackEvent({ action, category, label, value }: GAEvent) {
  if (typeof window === 'undefined' || !window.gtag || !hasAnalyticsConsent()) return;

  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
}

// Track exceptions
export function trackException(description: string, fatal: boolean = false) {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', 'exception', {
    description,
    fatal
  });
}

// Track timing
export function trackTiming(name: string, value: number, category?: string, label?: string) {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', 'timing_complete', {
    name,
    value,
    event_category: category,
    event_label: label
  });
}